import classNames from 'classnames';
import useGlobalParams from '../../hooks/useGlobalParams';
import useOrganizations from '../../hooks/useOrganizations';

import Modal from 'react-bootstrap/Modal';
import Button from '../../common/Button/Button';
import useCurrentUser from '../../hooks/useCurrentUser';

import { ReactComponent as CheckMarkIcon } from "../../assets/icons_svg/check-mark-outline-thin.svg";

import './WelcomeModal.scss';

export default function WelcomeModal({ show, onHide }) {
  const { organizationId } = useGlobalParams();
  const { data: organizations } = useOrganizations();
  const { currentUser, updateOnboarding } = useCurrentUser();

  const fromInvite = currentUser?.onboarding?.flow === 'from_invite';

  const organization = organizations?.find(organization => organization.id === organizationId);

  const onClose = () => {
    updateOnboarding({ show_welcome: false });
    onHide();
  }

  const renderInvite = () => (
    <>
      <div className='checkmark'><CheckMarkIcon /></div>
      <h2 className='invite'>Invitation Accepted</h2>
      <p className='invite'>You're now part of <strong>{ organization.name }</strong>.</p>
    </>
  );

  const renderWelcome = () => (
    <>
      <h2>Welcome to Precious Leads</h2>
      <p>We’re excited to have you here! Whether you’re just starting or you have an established busines, we’re happy to help you.</p>
      <p><strong>Here is our promise to you:</strong></p>
      <ul className="features">
        <li><CheckMarkIcon /><span><strong>Free forever plan.</strong> by signing up today and staying active, you will always have access to your leads. They’re precious and we understand that.</span></li>
        <li><CheckMarkIcon /><span><strong>No investor shenanigans.</strong> Precious Leads is made in Costa Rica by two developers in 2024 who grew tired of bloated commercial CRMs. We’re 100% boostrapped and we don’t need to please anyone but our clients.</span></li>
        <li><CheckMarkIcon /><span><strong>You’re our #1 priority.</strong> We have an ambitious Roadmap for 2027 including a native mobile app. If you email us or need support, a real human will always get back to you. We never use AI to respond to customers, ever.</span></li>
      </ul>
    </>
  );

  return organization && currentUser && (
    <Modal className={classNames("__modal __welcome-modal", { '__welcome-modal-big': !fromInvite })} show={show} backdrop='static' centered>
      <Modal.Body>
        { fromInvite ? renderInvite() : renderWelcome() }
      </Modal.Body>
      <Modal.Footer>
        <Button className='confirm' onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
